var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCloseIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 10,
    height: 10,
    viewBox: "0 0 10 10",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.82201 5.00049L0.244091 8.57841C-0.0813638 8.90345 -0.0813638 9.43185 0.244091 9.75689C0.56913 10.0823 1.09753 10.0823 1.42257 9.75689L5.00049 6.17896L8.57841 9.75689C8.90345 10.0823 9.43185 10.0823 9.75689 9.75689C10.0823 9.43185 10.0823 8.90345 9.75689 8.57841L6.17896 5.00049L9.75689 1.42257C10.0823 1.09753 10.0823 0.56913 9.75689 0.244091C9.43185 -0.0813638 8.90345 -0.0813638 8.57841 0.244091L5.00049 3.82201L1.42257 0.244091C1.09753 -0.0813638 0.56913 -0.0813638 0.244091 0.244091C-0.0813638 0.56913 -0.0813638 1.09753 0.244091 1.42257L3.82201 5.00049Z",
    fill: "#EF7C32"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCloseIcon);
export default __webpack_public_path__ + "static/media/close-icon.6049e4b1da9c67653c44daabe5d0c884.svg";
export { ForwardRef as ReactComponent };